import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=1d127a20&scoped=true&"
import script from "./AppIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d127a20",
  null
  
)

export default component.exports